import { createSlice } from "@reduxjs/toolkit";
import {
  getAllOrders,
  getOrderPdf,
  updateOrderStatus
} from "../api/purchaseOrder";

interface UsersState {
  loading: boolean;
  currentRequestId: undefined | string;
  userData: any;
  error: any;
}

const initialState = {
  loading: false,
  currentRequestId: undefined,
  userData: null,
  error: null,
} as UsersState;

export const purchaseOrderSlice = createSlice({
  name: "purchaseOrder",
  initialState,
  reducers: {
    resetPurchaseOrder: () => initialState,
  },
  extraReducers(builder) {
    builder
      .addCase(getAllOrders.pending, (state, action) => {
        state.loading = true;
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(getAllOrders.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading && state.currentRequestId === requestId) {
          state.loading = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(getAllOrders.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading && state.currentRequestId === requestId) {
          state.loading = false;
          state.currentRequestId = undefined;
          state.error = action.error;
        }
      })
      .addCase(getOrderPdf.pending, (state, action) => {
        state.loading = true;
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(getOrderPdf.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading && state.currentRequestId === requestId) {
          state.loading = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(getOrderPdf.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading && state.currentRequestId === requestId) {
          state.loading = false;
          state.currentRequestId = undefined;
          state.error = action.error;
        }
      })
      .addCase(updateOrderStatus.pending, (state, action) => {
        state.loading = true;
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(updateOrderStatus.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading && state.currentRequestId === requestId) {
          state.loading = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(updateOrderStatus.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading && state.currentRequestId === requestId) {
          state.loading = false;
          state.currentRequestId = undefined;
          state.error = action.error;
        }
      })
  },
});

export const { resetPurchaseOrder } = purchaseOrderSlice.actions;

export default purchaseOrderSlice.reducer;
